/**
 * Assumptions Bar Component
 * Displays the period selector and input fields for calculator assumptions
 */
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import { Users, Clock, DollarSign, Percent } from "lucide-react";

const AssumptionsBar = ({
  period,
  setPeriod,
  totalEmployees,
  hoursPerYear,
  setHoursPerYear,
  hourlyRate,
  setHourlyRate,
  overtimePercent,
  setOvertimePercent
}) => {
  return (
    <Card className="bg-secondary/30">
      <CardContent className="py-3">
        <div className="flex flex-wrap items-end gap-4">
          <div className="flex items-center gap-2">
            <Tabs value={period} onValueChange={setPeriod}>
              <TabsList className="h-8">
                <TabsTrigger value="monthly" className="text-xs px-3">Monthly</TabsTrigger>
                <TabsTrigger value="quarterly" className="text-xs px-3">Quarterly</TabsTrigger>
                <TabsTrigger value="annual" className="text-xs px-3">Annual</TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
          <Separator orientation="vertical" className="h-8 hidden sm:block" />
          <div className="flex flex-wrap items-end gap-3">
            <div className="space-y-1">
              <Label className="text-xs text-muted-foreground flex items-center gap-1">
                <Users className="w-3 h-3" />
                Total Employees
              </Label>
              <div className="text-sm font-semibold bg-background px-3 py-1 rounded border">
                {totalEmployees.toLocaleString()}
              </div>
            </div>
            <div className="space-y-1">
              <Label htmlFor="hours" className="text-xs text-muted-foreground flex items-center gap-1">
                <Clock className="w-3 h-3" />
                Hours/Year
              </Label>
              <Input
                id="hours"
                type="number"
                value={hoursPerYear}
                onChange={(e) => setHoursPerYear(Number(e.target.value))}
                className="h-8 w-24 text-sm"
              />
            </div>
            <div className="space-y-1">
              <Label htmlFor="rate" className="text-xs text-muted-foreground flex items-center gap-1">
                <DollarSign className="w-3 h-3" />
                Hourly Rate
              </Label>
              <Input
                id="rate"
                type="number"
                value={hourlyRate}
                onChange={(e) => setHourlyRate(Number(e.target.value))}
                className="h-8 w-20 text-sm"
              />
            </div>
            <div className="space-y-1">
              <Label htmlFor="ot" className="text-xs text-muted-foreground flex items-center gap-1">
                <Percent className="w-3 h-3" />
                OT %
              </Label>
              <Input
                id="ot"
                type="number"
                value={overtimePercent}
                onChange={(e) => setOvertimePercent(Number(e.target.value))}
                className="h-8 w-16 text-sm"
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AssumptionsBar;
